/**
 * Created by fkurzawa on 07.02.18.
 */
export const MENU_TYPES = {
  MENU_ITEM: "N",
  SUB_MENU: "D",
  SEPARATOR: "S"
};
